
function HarbourEn() {

    return (
        <div>
            <main>
                <section>
                    <div className="banner">
                        <img className='header-image' src="/assets/coast-img/harbour_banner.JPG" alt="harbour" />
                    </div>
                </section>
                <div className="content">
                    <article>
                        <div className="text">
                            <h1>Old Harbour</h1>
                            <p>Dating back to the 13th century, the history of Wismar's harbour goes back a long way. 
                                Back then it was a trading and transshipment centre, today it is a place of interest 
                                and home to many small shops and restaurants. Starting point for boat tours or 
                                anchorage for your own floating happiness. The huge and lovingly restored silo 
                                buildings, which served as grain stores, give an idea of the quantities of goods that 
                                were handled in the small town in the heyday of trade by water.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Tree House</h2>
                            <p>A small house from the middle of the 18th century, in the middle of the harbour tip. This 
                                is where the Bohmschlüter worked, whose job it was to close the harbour entrance with a 
                                floating tree at night or in case of imminent danger.<br></br>Today, two Swedish heads adorn 
                                the entrance to the building, another typical landmark for the Hanseatic city, which was 
                                under Swedish rule at the end of the 17th century.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Seeperle</h2>
                            <p>The absolute fish paradise. For a snack in between meals or as a filling lunch. For fish 
                                connoisseurs and those who want to become one. This restaurant is located south-west of the 
                                Old Harbour, opposite the ‘crooked’ vaulted house. Small snacks can also be enjoyed here or 
                                fish snacks can be taken home from the fish counter.<br></br>By the way, it's worth taking a 
                                look at the Seeperle website - the fish selection is huge.
                            </p>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    )
}

export default HarbourEn;